import { STORAGE_KEY_SESSION_READY } from '@/constants/storage';

const SESSION_READY_VALUE = '1';
const COOKIE_MAX_AGE = 365 * 24 * 60 * 60;

/** 是否已有「会话已建立」标记（回访 / 登出回游客后可直接发 waitForSession 请求） */
export function hasSessionReadyCookie(): boolean {
    if (typeof document === 'undefined') {
        return false;
    }
    const prefix = `${STORAGE_KEY_SESSION_READY}=`;
    return document.cookie.split(';').some(part => part.trimStart().startsWith(prefix));
}

/** postLogin 成功后写入；登出不清除（游客态仍有 token） */
export function setSessionReadyCookie(): void {
    if (typeof document === 'undefined') {
        return;
    }
    const secure = typeof window !== 'undefined' && window.location.protocol === 'https:';
    document.cookie = `${STORAGE_KEY_SESSION_READY}=${SESSION_READY_VALUE}; max-age=${COOKIE_MAX_AGE}; path=/; SameSite=Lax${
        secure ? '; Secure' : ''
    }`;
}

export function clearSessionReadyCookie(): void {
    if (typeof document === 'undefined') {
        return;
    }
    const secure = typeof window !== 'undefined' && window.location.protocol === 'https:';
    document.cookie = `${STORAGE_KEY_SESSION_READY}=; max-age=0; path=/; SameSite=Lax${secure ? '; Secure' : ''}`;
}
